export const ecdsMapObservations = [
    {obs: 'respiration', ecds: '86290005'},
    {obs: 'spo2scale', ecds: '103228002'},
    {obs: 'bloodPressure', ecds: '72313002'},
    {obs: 'pulseRate', ecds: '78564009'},
    {obs: 'consciousness', ecds: '1104441000000107'},
    {obs: 'temperature', ecds: '276885007'},
];

export const ecdsMapAssessment = [
    {obs: 'respiration', ecds: '1104301000000104'},
    {obs: 'spo2scale1', ecds: '1104311000000102'},
    {obs: 'spo2scale2', ecds: '1104321000000108'},
    {obs: 'airOxygen', ecds: '1104331000000105'},
    {obs: 'bloodPressure', ecds: '1104341000000101'},
    {obs: 'pulseRate', ecds: '1104351000000103'},
    {obs: 'consciousness', ecds: '1104361000000100'},
    {obs: 'temperature', ecds: '1104371000000107'},
    {obs: 'total', ecds: '1104051000000101'},
    {obs: 'painScore', ecds: '1144798005'},
    {obs: 'delirium', ecds: '1239211000000103'},
    {obs: 'rockwood', ecds: '763264000'},
];

export const airOrOxygen = [
    {id: 'oxygen', value: 'Patient on oxygen'},
    {id: 'room', value: 'Breathing room air'},
];